import React from "react";

import { ArrayParam, useQueryParams, withDefault } from "use-query-params";

import { Box } from "@chakra-ui/react";

import { useGetUsersMinimal } from "../../../graphql/generated/definitions";

import useTranslations from "../../../hooks/useTranslations";

const ReportSignatoriesBoxes = () => {
  const t = useTranslations();
  const [{ signatoryIds }] = useQueryParams({
    signatoryIds: withDefault(ArrayParam, []),
  });

  const { data: signatoriesData } = useGetUsersMinimal({
    variables: {
      idsStrict: signatoryIds,
    },
    skip: signatoryIds.length === 0,
  });

  const signatories = signatoriesData?.users?.collection || [];

  if (signatories.length === 0) return null;

  return (
    <Box py="16">
      <Box fontSize="xl" fontWeight="bold">
        {t("reports.signature.header")}
      </Box>
      <Box mx="auto" pt="10">
        {signatories.map((signatory) => (
          <Box
            key={signatory.id}
            display="inline-block"
            rounded="sm"
            border="1px solid"
            borderColor="black"
            h="15vh"
            w="calc(30% - 2rem)"
            p="4"
            ml="8"
          >
            <Box fontSize="medium" fontWeight="semibold">
              {signatory.name}
            </Box>
            <Box
              m="auto"
              sx={{
                color: "#FFFFFF !important",
              }}
              fontSize="xs"
            >{`__Docusign__${signatory.id}`}</Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ReportSignatoriesBoxes;
